export default __webpack_public_path__ + "static/media/selectCard.056e9d48.svg";